const STEPS = [
  {
    num: "01",
    title: "Devis en Ligne",
    desc: "Remplissez les références du calculateur et recevez votre proposition chiffrée sous 2h.",
  },
  {
    num: "02",
    title: "Envoi par la Poste",
    desc: "Emballez votre calculateur et expédiez-le par Colissimo ou Chronopost : NeoElec Auto, 7 Rue Mozart, 57270 Uckange.",
  },
  {
    num: "03",
    title: "Intervention & Test",
    desc: "Reprogrammation ou clonage réalisé, puis contrôle complet sur banc avant validation.",
  },
  {
    num: "04",
    title: "Paiement & Renvoi",
    desc: "Paiement par carte en ligne et renvoi de votre boîtier en express suivi 24h à votre adresse.",
  },
];

export const Steps = () => (
  <section id="expedition" className="py-24 md:py-32 px-6 border-b border-[#1C2C4E]">
    <div className="max-w-6xl mx-auto">
      <div className="text-center max-w-xl mx-auto mb-16">
        <p className="font-mono text-xs uppercase tracking-[0.14em] text-[#51ADDA] mb-2">Protocole Postal Simplifié</p>
        <h2 className="font-display text-4xl uppercase tracking-tight text-white">Comment ça marche ?</h2>
      </div>

      <div className="grid md:grid-cols-4 gap-6">
        {STEPS.map((s) => (
          <div key={s.num} className="p-6 rounded bg-[#0F1D36] border border-[#1C2C4E]">
            <span className="font-mono text-xs text-[#51ADDA] block mb-4">{s.num}</span>
            <h4 className="font-display text-lg uppercase text-white mb-2">{s.title}</h4>
            <p className="text-slate-400 text-xs leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
